module.exports = __webpack_public_path__ + "img/police-car-light.65489897.png";